import { FunctionComponent, ReactNode } from "react";
import ModalBase from "../base";
import { BasicButtonType } from "../../buttons/basic";

export type ModalType = {
  className?: string;
  description?: string;
  title?: string;
  showCloseButton?: boolean;
  showHandleBar?: boolean;
  
  /** Content prop */
  content?: ReactNode;

  /** Variant props */
  height?: "hug-content" | "fill-container";
  type?: "auto" | "bottom" | "overlay";

  /* Custom props */
  buttonPrimary?: BasicButtonType;
  buttonSecondary?: BasicButtonType;
  show: boolean;
  onClose?: () => void;
  customIcon?: ReactNode;
  customImage?: string;
};

export const Modal: FunctionComponent<ModalType> = ({
  className = "",
  height = "hug-content",
  type = "bottom",
  description = "Add the content here",
  title = "Title",
  buttonPrimary,
  buttonSecondary,
  show,
  onClose,
  showCloseButton,
  showHandleBar,
  customIcon,
  customImage,
  content,
}) => {
  return (
    <ModalBase
      className={className}
      height={height}
      type={type}
      description={description}
      title={title}
      buttonPrimary={buttonPrimary}
      buttonSecondary={buttonSecondary}
      show={show}
      onClose={onClose}
      showCloseButton={showCloseButton}
      showHandleBar={showHandleBar}
      customIcon={customIcon}
      customImage={customImage}
      content={content}
    />
  );
};

export default Modal;
